<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { getImageUrl } from '../../../utils/getImageUrl';
	import { HeroWithPlatformLogo } from '../HeroWithPlatformLogo';
	import type { Hero as HeroType } from '../types';

	interface Props {
		class?: string;
		hero: HeroType;
		isLive: boolean;
		enforcedDesktopImage?: string | null;
		enforcedMobileImage?: string | null;
		disableLinks?: boolean;
		desktopImageStyle?: string;
		mobileImageStyle?: string;
	}

	let {
		hero,
		isLive,
		enforcedDesktopImage,
		enforcedMobileImage,
		disableLinks = false,
		desktopImageStyle,
		mobileImageStyle,
		...rest
	}: Props = $props();

	let desktopImage = $derived(
		enforcedDesktopImage || getImageUrl(hero?.desktop_image?.filename_disk, '2048px')
	);

	let mobileImage = $derived(
		enforcedMobileImage || getImageUrl(hero?.mobile_image?.filename_disk, '2048px')
	);

	const handleClick = (e?: Event) => {
		if (disableLinks && e) {
			e.preventDefault();
		}
	};
</script>

<HeroWithPlatformLogo
	dataCy="primary-home"
	hero={{
		...hero,
		button_1_variant: hero.button_1_variant || 'ghost'
	}}
	align="center"
	class={twMerge('[&_a>button]:w-full', rest.class)}
	showPlatformLogo={false}
	alt={hero.surtitle}
	classes={{
		mobileImage: '@lg:object-[50%_30%]',
		image: 'object-[50%_30%]'
	}}
	imageBreakpoint="xl"
	{isLive}
	enforcedDesktopImage={desktopImage}
	enforcedMobileImage={mobileImage}
	{desktopImageStyle}
	{mobileImageStyle}
	onclick={handleClick}
/>
